// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".N9_Cr{color:var(--delivery-out-of-stock)}.HOY_h{color:var(--delivery-waiting)}.Rla4B{color:var(--delivery-in-stock)}", "",{"version":3,"sources":["webpack://./src/components/organisms/products/productSingleResult/delivery.module.scss"],"names":[],"mappings":"AAAA,OACI,kCAAA,CAGJ,OACI,6BAAA,CAGJ,OACI,8BAAA","sourcesContent":[".delivery-out-of-stock {\n    color: var(--delivery-out-of-stock);\n}\n\n.delivery-waiting {\n    color: var(--delivery-waiting);\n}\n\n.delivery-in-stock {\n    color: var(--delivery-in-stock);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"delivery-out-of-stock": "N9_Cr",
	"deliveryOutOfStock": "N9_Cr",
	"delivery-waiting": "HOY_h",
	"deliveryWaiting": "HOY_h",
	"delivery-in-stock": "Rla4B",
	"deliveryInStock": "Rla4B"
};
export default ___CSS_LOADER_EXPORT___;
